/*
 * @Author: syyoon@yongtrim.com 
 * @Date: 2018-12-26 15:54:11 
 * @Last Modified by:   syyoon@yongtrim.com 
 * @Last Modified time: 2018-12-26 15:54:11 
 */

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ENV } from '../env/env';
import { TransService } from './trans.service';

@Injectable()
export class NotificationService {

  private url = `${ENV.SERVER_URL}/${ENV.API_PATH}/notifications`;

  constructor(
    private transService: TransService,
    private http: HttpClient) {
  }

  getNotifications(page: number) {
    return this.http.get(`${this.url}?page=${page}&lang=${this.transService.lang}`);
  }

}



// WEBPACK FOOTER //
// ./src/services/notificatin.service.ts